import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-model-detail-model-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './model-tab.component.html',
  styleUrl: './model-tab.component.scss',
})
export class ModelDetailModelTabComponent {
  readonly detailRows = input.required<Record<string, string>>();
  readonly modelDescription = input<string>('');
  readonly modelTags = input<string[]>([]);
  readonly activityMetrics = input({
    likes: 0,
    views: 0,
    downloads: 0,
  });
  /** Repository / redirect URL from catalogue item (`mediaURL`, `mediaUrl`, etc.). */
  readonly mediaUrl = input<string>('');

  formatMetric(n: number | undefined): string {
    const v = n ?? 0;
    if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
    if (v >= 1_000) return `${(v / 1_000).toFixed(1)}k`;
    return String(v);
  }

  hasGithubAction(): boolean {
    const u = this.mediaUrl()?.trim();
    return !!u;
  }

  onGithubRepoClick(): void {
    const url = this.mediaUrl()?.trim();
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
}
